import useAppSelector from '../app/redux/useAppSelector';
import { AllowPublicContentBy } from '../graphql/generated/graphql';

const usePublicContentPermissions = () => {
  const user = useAppSelector((state) => state.session.user);

  const organization = useAppSelector((state) => state.session.organization);
  const allowPublicContentBy =
    organization.settings.allowPublicContentBy ?? null;

  const isAdmin = user.type === 'ADMIN';

  return {
    isPermittedToPublicizePost:
      isAdmin ||
      allowPublicContentBy === AllowPublicContentBy.All ||
      allowPublicContentBy === AllowPublicContentBy.AdminTopicsUserPosts,
    isPermittedToSetTopicToPublic:
      isAdmin || allowPublicContentBy === AllowPublicContentBy.All,
    isPermittedToCreatePublicSubtopic:
      isAdmin || allowPublicContentBy === AllowPublicContentBy.All,
  };
};

export default usePublicContentPermissions;
